import { apiClient } from './authService';

// Boutiques (owner 2026-09-28) : Ki Para, Ki Para Boutique, Ki Para 2…
// Chaque compte vendeur / manager et chaque personne en a une ; le
// propriétaire n'en a pas (toutes les boutiques).
const fail = (error, message) => { throw error.response?.data || { detail: message }; };

const storeService = {
  list: async () => {
    try {
      const { data } = await apiClient.get('auth/stores/');
      return Array.isArray(data) ? data : (data?.results || []);
    } catch (e) { return fail(e, 'Impossible de charger les boutiques.'); }
  },
  save: async ({ id, ...payload }) => {
    try {
      const { data } = id
        ? await apiClient.patch(`auth/stores/${id}/`, payload)
        : await apiClient.post('auth/stores/', payload);
      return data;
    } catch (e) { return fail(e, "Impossible d'enregistrer la boutique."); }
  },
};

export default storeService;
